export const EMAIL_REGEX: RegExp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
export const ZIPCODE_REGEX: RegExp = new RegExp(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i);
export const SPECIAL_CHAR_REGEX: RegExp = new RegExp(/^[^A-Za-z0-9]$/i);
export const PHONE_REGEX: RegExp = new RegExp(/(?=([0-9-+\s]*?\d){10,})^([+\s]?[0-9\s]{2,}[-,\s]?[0-9\s]{6,})$/i);
export const VALID_CHARACTERS_REGEX: RegExp = new RegExp(/[^\u0020-\u007e\u00a0-\u00ff]/i);
export const HOUSENUMBER_REGEX: RegExp = new RegExp(/^(\d+[- \w]*)$/);